import { Box } from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';

export const FormulaContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Box
      fontSize="sm"
      padding="16px"
      backgroundColor={colors.gray[200]}
      borderRadius="8px"
      color="black"
    >
      {children}
    </Box>
  );
};
